/**
 * docs/09-BUILD-PLAN.md Phase 6 step 12 — the contact inbox and the redirect
 * manager.
 */

/* ── docs/05-ADMIN-DASHBOARD.md §5.7 ─────────────────────────────────── */

/** docs/03-DATA-MODEL.md §9's `status` enum, in the order §5.7 transitions. */
export const SUBMISSION_STATUSES = ['new', 'read', 'replied', 'archived', 'spam'] as const;

export type SubmissionStatus = (typeof SUBMISSION_STATUSES)[number];

export interface SubmissionRow {
  id: number;
  /** What the visitor was shown on the confirmation screen. */
  reference: string | null;
  name: string;
  email: string;
  subject: string;
  message: string;
  status: SubmissionStatus;
  notes: string | null;
  handled_by: { id: number; name: string } | null;
  handled_at: string | null;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string | null;
  updated_at: string | null;
  deleted_at: string | null;
}

export interface SubmissionCounts {
  data: Partial<Record<SubmissionStatus, number>>;
  /** §5.7 — "Show the retention policy in the UI so staff know old records are purged." */
  retention: { spam_days: number; archived_months: number };
}

/* ── docs/05-ADMIN-DASHBOARD.md §5.8 ─────────────────────────────────── */

/** docs/03-DATA-MODEL.md §8's `source` enum. */
export const REDIRECT_SOURCES = ['manual', 'migration', 'slug_change'] as const;

export type RedirectSource = (typeof REDIRECT_SOURCES)[number];

export interface RedirectRow {
  id: number;
  from_path: string;
  to_path: string;
  status_code: number;
  source: RedirectSource;
  hit_count: number;
  last_hit_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  /** Always null: §8 gives this table no `deleted_at`. */
  deleted_at: null;
}

export interface RedirectInput {
  from_path: string;
  to_path: string;
  status_code: number;
  source: RedirectSource;
}

export interface NotFoundRow {
  id: number;
  path: string;
  hit_count: number;
  /** Who is still linking here — a ministry site, or a bot walking WordPress paths. */
  referer: string | null;
  first_seen_at: string | null;
  last_seen_at: string | null;
}
